(ns frontend.view.grid.sales-opportunities-grid.events
  (:require
   [common.attribute :as attribute]
   [common.localization :as loc]
   [common.schema.entity-type-names :as entity-type-names]
   [common.schema.entity-types :as entity-types]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.actions.named-view :as named-view-actions]
   [frontend.actions.sales-opportunity :as sales-opportunity-actions]
   [frontend.conn :as conn]
   [frontend.local-storage :as ls]
   [frontend.logging :as logging]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.utils :as fu]
   [frontend.view.entity :as f-entity]
   [frontend.view.grid.companies-grid.events :as companies-events]
   [frontend.view.grid.investors-grid.events :as investors-events]
   [frontend.view.grid.persons-grid.events :as persons-events]
   [frontend.view.grid.sales-opportunities-grid.columns :as columns]
   [frontend.view.grid.sales-opportunities-grid.db :as db]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]
   [frontend.zap-time :as zap-time]
   [potpuri.core :refer [fn->]]
   [promesa.core :as p]
   [reagent.core :as r]))

(defn system-views
  []
  [{:named-view/settings {:selected-columns columns/default-columns
                          :ordered-columns  columns/ordered-default-columns
                          :view-mode        :board-mode
                          :filters          {:sales-opportunity/status
                                             {:operand :operand/any-of
                                              :lower-bound-value
                                              #{:sales-opportunity.status/active}}}
                          :sort-by          :sales-opportunity/name
                          :sort-direction   "DESC"}
    :named-view/name     (loc/tr :active-pipeline)
    :disable-delete?     true
    :db/id               "named-view-sales-active-pipeline"}
   {:named-view/settings {:selected-columns columns/default-columns
                          :ordered-columns  columns/ordered-default-columns
                          :view-mode        :grid-mode
                          :sort-by          :sales-opportunity/name
                          :sort-direction   "ASC"}
    :named-view/name     (loc/tr :all-sales-opportunities)
    :disable-delete?     true
    :db/id               "named-view-sales-all-opportunities"}
   {:named-view/settings
    {:selected-columns columns/my-sales-opportunities-columns
     :ordered-columns  columns/my-sales-opportunities-ordered-columns
     :view-mode        :grid-mode
     :sort-by          :sales-opportunity/name
     :sort-direction   "ASC"
     :filters          {:sales-opportunity/owner {:operand           :operand/any-of
                                                  :lower-bound-value #{(:db/id
                                                                        @session/account)}}}}
    :named-view/name (loc/tr :my-sales-opportunities)
    :disable-delete? true
    :db/id           "named-view-my-sales-opportunities"}

   {:named-view/settings {:selected-columns columns/lost-sales-opportunities-columns
                          :ordered-columns  columns/lost-sales-opportunities-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:sales-opportunity/status
                                             {:operand           :operand/any-of
                                              :lower-bound-value #{:sales-opportunity.status/lost}}}
                          :sort-by          :sales-opportunity/lost-on
                          :sort-direction   "DESC"}
    :named-view/name     (loc/tr :lost-sales-opportunities)
    :disable-delete?     true
    :db/id               "named-view-lost-sales-opportunities"}
   {:named-view/settings {:selected-columns columns/sales-opportunities-on-hold-columns
                          :ordered-columns  columns/sales-opportunities-on-hold-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:sales-opportunity/status
                                             {:operand :operand/any-of
                                              :lower-bound-value
                                              #{:sales-opportunity.status/on-hold}}}
                          :sort-by          :sales-opportunity/put-on-hold-on
                          :sort-direction   "DESC"}
    :named-view/name     (loc/tr :sales-opportunities-on-hold)
    :disable-delete?     true
    :db/id               "named-view-sales-opportunities-on-hold"}])

(defn system-views-by-id
  []
  (->> (system-views)
       (map (fn [v]
              [(:db/id v) v]))
       (into {})))

(defn named-views
  []
  (concat (system-views)
          (->> @session/all-named-views
               (cu/only-entity :named-view/view :sales-opportunities-grid)
               (sort-by :common/created-on))))

(defn named-view-by-id
  [id]
  (or (get @session/entities id)
      (get (system-views-by-id) id)))

(defn ls-path
  [& rest]
  (concat
   [(:db/id @session/account)
    (:db/id @session/tenant)
    :sales-opportunities-view-settings]
   rest))

(declare setup-column-state!)

(defn load-view!
  [named-view]                                                                                      ;;named-view entity
  (let [{:keys [named-view/settings]} named-view]
    (ls/set-in (ls-path) settings)
    (setup-column-state! settings)))

(defn save-current-view!
  [name]
  (let [settings @db/view-settings
        msg {:named-view/name     name
             :named-view/view     :sales-opportunities-grid
             :named-view/settings settings}]
    (named-view-actions/*create-named-view->
     msg
     identity
     (fn [& a]                                                                                      ;;TODO show error message
       (logging/error "create-named-view failed" a)))))

(defn get-label
  [k]
  (let [customer-types (session/sales-opportunity-customer-asset-types)
        tenant-schema @session/tenant-schema
        ref-field? (vector? k)
        [_ customer-field] (when (and (vector? k)
                                      (= (first k)
                                         :sales-opportunity/customer))
                             k)
        customer-fs (when customer-field
                      (registry/get-field-schema tenant-schema customer-field))]
    (cond
      (nil? k)
      nil

      (keyword? k)
      (let [fs (registry/get-field-schema tenant-schema k)]
        (loc/field-name k fs))

      (and ref-field?
           (= (count customer-types) 1))
      (attribute/attribute-label tenant-schema k)

      (and ref-field?
           (> (count customer-types) 1)
           (contains? #{"common" "customer"} (namespace customer-field)))
      (attribute/attribute-label tenant-schema k)

      (and ref-field?
           (> (count customer-types) 1)
           (contains? #{"company" "asset"} (namespace customer-field)))
      (loc/tr :customer-field-specified
        [(loc/tr :company-lc) (loc/field-name customer-field customer-fs)])

      (and ref-field?
           (> (count customer-types) 1)
           (contains? #{"person"} (namespace customer-field)))
      (loc/tr :customer-field-specified
        [(loc/tr :person-lc) (loc/field-name customer-field customer-fs)])

      (and ref-field?
           (> (count customer-types) 1)
           (contains? #{"investor"} (namespace customer-field)))
      (loc/tr :customer-field-specified
        [(loc/tr :investor-lc) (loc/field-name customer-field customer-fs)])

      :else
      (attribute/attribute-label tenant-schema k))))

(defn precalculated-schema
  [recalculate?]
  (let [calculated @db/schema
        pipeline @session/selected-sales-oppo-pipeline
        schema (cond
                 (and (not recalculate?)
                      calculated)
                 calculated
                 :else
                 (->>
                  (registry/get-schema @session/tenant-schema :entity.type/sales-opportunity)
                  (remove
                   (fn [[k v]]
                     (let [grid-visibility (->> v
                                                :field/default-visibility
                                                :grid)
                           not-available?
                           (or (columns/not-available k)
                               (nil? grid-visibility)
                               (= grid-visibility :editor.type/none)
                               (if (or (not= (:field/data-type v) :data.type/currency-symbol)
                                       (not (:field/secondary-field? v)))
                                 (not (f-permissions/field-read-access?
                                       k
                                       :entity.type/sales-opportunity
                                       pipeline))
                                 (not (f-permissions/field-read-access?
                                       (:field/related-fields v)
                                       :entity.type/sales-opportunity
                                       pipeline))))]
                       not-available?)))
                  (sort-by (fn [[_k v]]
                             (-> v
                                 :field/translations
                                 :en)))))
        ;; TODO: customer schema should be any of the supported types ?
        customer-types (session/sales-opportunity-customer-asset-types)
        allowed-customer-types (set customer-types)
        asset-type-schema
        (fn [entity-type]
          (when (and (some #{entity-type} allowed-customer-types)
                     (or recalculate?
                         (not calculated)))
            (->> (case entity-type
                   :entity.type/company
                   (companies-events/precalculated-schema recalculate?)
                   :entity.type/investor
                   (investors-events/precalculated-schema recalculate?)
                   :entity.type/person
                   (persons-events/precalculated-schema recalculate?)
                   nil)
                 ;;remove fields that are inactive in this pipeline
                 (remove (fn [[k v]]
                           (if (not= (:field/data-type v) :data.type/currency-symbol)
                             (not (f-permissions/field-read-access? k
                                                                    entity-type
                                                                    pipeline))
                             (not (f-permissions/field-read-access? (:field/related-fields v)
                                                                    entity-type
                                                                    pipeline))))))))
        asset-schema (->> allowed-customer-types
                          (mapcat asset-type-schema)
                          (keep (fn [[k v]]
                                  ;; only one chain of indirection for simplicity
                                  ;; (i.e. don't include [:sales-opportunity/customer :investor/legal-entity LEGAL-ENTITY-FIELDS]):
                                  (when-not (vector? k)
                                    [[:sales-opportunity/customer k] v])))
                          (into {})
                          (remove (fn-> first (= [:sales-opportunity/customer :asset/name])))
                          (sort-by (fn [[_ v]]
                                     (-> v
                                         :field/translations
                                         :en)))
                          doall)

        schema (if (and (not recalculate?)
                        calculated)
                 schema
                 (concat schema asset-schema))]
    (when (or recalculate?
              (not calculated))
      (reset! db/schema schema))
    schema))

;;precalculate for performance reasons
(defn keys-and-schemas
  []
  (precalculated-schema false))

(defn sales-opportunity-column-keys
  []
  (concat
   (when (session/is-admin?) [:db/id])
   (map first (keys-and-schemas))))

(def default-kanban-attributes
  [:sales-opportunity/cur-estimated-ARR
   :sales-opportunity/overview
   :sales-opportunity/description])

(defn visible-keys-and-schemas
  []
  (let [{:keys [attributes footer-1 footer-2]} @db/card-settings
        visible-attributes
        (set (concat @db/selected-columns
                     attributes
                     default-kanban-attributes
                     [footer-1 footer-2
                      (entity-types/type->owner-attribute :entity.type/sales-opportunity)]))]
    (->> (keys-and-schemas)
         (filter (fn [[k _fs]]
                   (some #{k} visible-attributes))))))

(declare expanded? toggle-expand!)

(defn column-tabs
  []
  (let [target-asset-types (session/sales-opportunity-customer-asset-types)]
    (->> (concat [:entity.type/sales-opportunity :entity.type/customer]
                 target-asset-types)
         (map (fn [entity-type]
                (let [entity-type-name (-> entity-type-names/entities
                                           (get entity-type)
                                           :field/translations
                                           :en)]
                  {:key   entity-type
                   :label (loc/tr :entity-type-fields [entity-type-name])}))))))

(defn resolve-tab
  [field]
  (let [target-asset-types (session/sales-opportunity-customer-asset-types)
        ref-field? (and (vector? field)
                        (keyword? (first field))
                        (keyword? (second field)))
        [_ attr] (when ref-field?
                     field)]
    (cond
      (keyword? field)
      :entity.type/sales-opportunity
      (and ref-field?
           (= (count target-asset-types) 1))
      (first target-asset-types)
      (and ref-field?
           (contains? #{"customer" "common"} (namespace attr)))
      :entity.type/customer
      (and ref-field?
           (contains? #{"company" "asset"} (namespace attr)))
      :entity.type/company
      (and ref-field?
           (= (namespace attr) "person"))
      :entity.type/person
      (and ref-field?
           (= (namespace attr) "investor"))
      :entity.type/investor
      :else
      :unknown)))

;;necessary arguments to use common grid functions
(defn setup-args
  []
  {:state                       db/sales-opportunities
   :entity-type                 :entity.type/sales-opportunity
   :modal-state                 db/modal-state
   :selected-columns-state      db/selected-columns
   :ordered-columns-state       db/ordered-columns
   :filters-state               db/sales-opportunity-filters
   :view-settings-state         db/view-settings
   :column-widths-state         db/column-widths
   :selected-pipeline           @session/selected-sales-oppo-pipeline
   :ls-path                     ls-path
   :containing-entity           (->> @session/selected-sales-oppo-pipeline
                                     (get @session/entities))
   :kanban-args                 {:default-grouped-by           :sales-opportunity/stage
                                 :kanban-state                 db/kanban
                                 :grouped-by-state             db/grouped-by
                                 :card-settings-state          db/card-settings
                                 ;;for long card view:
                                 :default-attributes           default-kanban-attributes
                                 :expanded-state               db/expanded
                                 :sorted-kanban-entities-state db/sorted-kanban-entities
                                 :lists-state                  db/lists
                                 :expanded?                    expanded?
                                 :toggle-expand!               toggle-expand!}
   :kanban?                     true
   :column-keys                 sales-opportunity-column-keys
   :column-tabs                 (column-tabs)
   :resolve-tab                 resolve-tab
   :default-columns             columns/default-columns
   :mandatory?                  columns/mandatory?
   :visible-keys-and-schemas-fn visible-keys-and-schemas
   :custom-filters              {:sales-opportunity/pipeline {:operand :operand/all-of
                                                              :lower-bound-value
                                                              #{@session/selected-sales-oppo-pipeline}}}})

(defn resolve-column-key-universe
  []
  (grid/resolve-column-key-universe (setup-args)))

(defn resolve-column-keys
  []
  (grid/resolve-column-keys (setup-args)))

(defn cleanup
  []
  (when-let [tracker (:tracker-1 @db/sales-opportunities)]
    (r/dispose! tracker))
  (when-let [tracker (:tracker-2 @db/sales-opportunities)]
    (r/dispose! tracker))
  (when-let [tracker (:tracker-3 @db/sales-opportunities)]
    (r/dispose! tracker))

  (swap! db/sales-opportunities dissoc
         :loaded
         :schema
         :entities
         :entity-types
         :view-settings
         :sorted-grid-entities
         :sorted-kanban-entities
         :search
         :kanban
         :selected
         :grid-entities))

(defn setup-column-state!
  [view-settings]
  (reset! db/view-settings view-settings)
  (when (nil? @db/selected-columns)
    (let [default-view-settings (->> (named-views)
                                     first
                                     :named-view/settings)]
      (reset! db/view-settings default-view-settings)
      (ls/set-in (ls-path) default-view-settings)))
  (grid/recalculate (assoc (setup-args) :re-sort? true)))

(defn sale-opportunities-updates
  []
  (let [sales-opportunities (->> @session/all-sales-opportunities
                                 (cu/filter-by :sales-opportunity/pipeline
                                               @session/selected-sales-oppo-pipeline))]
    (swap! db/sales-opportunities assoc :grid-entities sales-opportunities)))

(defn permission-updates
  []
  (let [current-permissions @session/current-permissions]
    (when current-permissions
      (precalculated-schema true))))

(defn trigger-recalculation
  []
  (let [permissions-trigger @db/schema
        entities-trigger @db/grid-entities]
    (when (or permissions-trigger entities-trigger)
      (fu/timeout 10
                  (fn []
                    (grid/recalculate (assoc (setup-args) :stale-sort? true))
                    (swap! db/sales-opportunities assoc :loaded true)
                    (deref db/sales-opportunities))))))

(defn setup
  [closed-atom?]
  (when-not @closed-atom?
    (if (empty? (ls/get-in (ls-path)))
      (load-view! (first (named-views)))
      (reset! db/view-settings (ls/get-in (ls-path))))
    (swap! db/sales-opportunities assoc
           :tracker-1 (r/track! sale-opportunities-updates)
           :tracker-2 (r/track! permission-updates)
           :tracker-3 (r/track! trigger-recalculation))
    (setup-column-state! (ls/get-in (ls-path)))))

(defn toggle-quick-filters!
  []
  (swap! db/sales-opportunities update :show-quick-filters? not))

(defn switch-mode!
  [current-mode]
  (let [new-mode (if (= current-mode :grid-mode) :board-mode :grid-mode)]
    (swap! db/view-settings assoc :view-mode new-mode)
    (ls/update-in (ls-path) assoc :view-mode new-mode)))

(defn mass-delete!
  []
  (-> (conn/sendp! :sales-opportunity/mass-action
                   {:action                :delete-sales-opportunities
                    :sales-opportunity-ids (grid/get-selected-items (setup-args))})
      (p/then (fn [_args]
                (swap! db/sales-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to delete selected sales-opportunities" e)))))

(defn mass-apply-tags!
  [selected-tag]
  (-> (conn/sendp! :sales-opportunity/mass-action
                   {:action                :add-tag-to-all
                    :sales-opportunity-ids (grid/get-selected-items (setup-args))
                    :tag-ids               (into [] selected-tag)})
      (p/then (fn [_args]
                (swap! db/sales-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to apply tags to selected sales-opportunities" e)))))

(defn mass-remove-tags!
  [selected-tags]
  (-> (conn/sendp! :sales-opportunity/mass-action
                   {:action                :remove-tags-from-all
                    :sales-opportunity-ids (grid/get-selected-items (setup-args))
                    :tag-ids               (into [] selected-tags)})
      (p/then (fn [_args]
                (swap! db/sales-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to remove tags to selected sales-opportunities" e)))))

(defn open-selected!
  [_]
  (let [sales-opportunity-id (-> (grid/get-selected-items (setup-args))
                                 (first))]
    (routing/open-entity sales-opportunity-id)))

(defn delete-selected-clicked
  [_]
  (modals/open-modal!
   confirmation/modal-key
   {:body          [:div
                    [:p (loc/tr :confirm-delete-selected)]]
    :confirm-text  (loc/tr :confirm-delete-selected-button)
    :checkbox-text (loc/tr :confirm-delete-selected-checkbox)
    :on-confirm    #(mass-delete!)}))

(defn expanded?
  [entity-id]
  (let [card-mode (or (:card-mode @db/kanban)
                      :short-card)
        individual (get @db/expanded entity-id)]
    (or (and (= card-mode :short-card)
             individual)
        (and (= card-mode :long-card)
             (not individual)))))

(defn toggle-expand!
  [entity-id]
  (let [expanded? (get @db/expanded entity-id)]
    (if expanded?
      (swap! db/expanded dissoc entity-id)
      (swap! db/expanded assoc entity-id true))))

(defn show-collapse-all?
  []
  (let [card-mode (or (:card-mode @db/kanban)
                      :short-card)
        individual-count (count @db/expanded)
        total-entity-count (count @db/sorted-kanban-entities)]
    (or (and (= card-mode :short-card)
             (> individual-count 0))
        (and (= card-mode :long-card)
             (< individual-count total-entity-count)))))

(defn expand-all!
  []
  (swap! db/kanban assoc :card-mode :long-card)
  (reset! db/expanded {}))

(defn collapse-all!
  []
  (swap! db/kanban assoc :card-mode :short-card)
  (reset! db/expanded {}))

(defn open-card-settings!
  []
  (swap! db/kanban assoc :card-settings? true))

(defn close-card-settings!
  []
  (swap! db/kanban dissoc :card-settings?))

(defn resurrect!
  [entity]
  (sales-opportunity-actions/*->resurrect!
   {:sales-opportunity-id (:db/id entity)}
   (fn [_])
   (fn [err]
     (logging/error "Failed to reactivate froppo " err))))

(defn agreement-start-value
  [entity]
  (let [fo-owner (:sales-opportunity/owner entity)
        fo-credit (:sales-opportunity/credit entity)]
    (merge
     {:sale-agreement/owner    (or (session/active-account-id fo-owner)
                                   (:db/id @session/account))
      :sale-agreement/customer (:sales-opportunity/customer entity)}
     (when (f-permissions/field-write-access? :sale-agreement/won-by
                                              :entity.type/sale-agreement
                                              nil)
       {:sale-agreement/won-by (or (session/active-account-id fo-credit)
                                   (session/active-account-id fo-owner)
                                   (:db/id @session/account))})
     (when (f-permissions/field-write-access? :sale-agreement/credit
                                              :entity.type/sale-agreement
                                              nil)
       {:sale-agreement/credit (or (session/active-account-id fo-credit)
                                   (session/active-account-id fo-owner)
                                   (:db/id @session/account))})
     (when (f-permissions/field-write-access? :sale-agreement/cur-committed-amount
                                              :entity.type/sale-agreement
                                              nil)
       {:sale-agreement/cur-committed-amount
        (or (:sales-opportunity/cur-estimated-ARR entity)
            (:sales-opportunity/cur-offered-price entity))
        :sale-agreement/cur-committed-amount--sym
        (or (:sales-opportunity/cur-estimated-ARR--sym entity)
            (:sales-opportunity/cur-offered-price--sym entity))})
     (when (f-permissions/field-write-access? :sale-agreement/committed-date
                                              :entity.type/sale-agreement
                                              nil)
       {:sale-agreement/committed-date (zap-time/now)})
     (when-let [target (:sales-opportunity/offered-asset entity)]
       (when (f-permissions/field-write-access? :sale-agreement/sale-target
                                                :entity.type/sale-agreement
                                                nil)
         {:sale-agreement/sale-target target})))))

(defn won!
  [{:keys [entity reset-focus!]}]
  (swap! db/won-modal* assoc
         :won-modal-open? true
         :won-modal-entity entity
         :reset-focus! reset-focus!)

  #_(f-entity/open-creator!
     :entity.type/sale-agreement
     (merge
      {:start-value   (agreement-start-value entity)
       :on-processed! (fn [{:keys [new-entity-id close-cb!]}]
                        (sales-opportunity-actions/*->won!
                         {:sales-opportunity-id (:db/id entity)
                          :sale-agreement-id    new-entity-id}
                         (fn [_]
                           (close-cb!))
                         (fn [err]
                           (logging/error "Failed to set sales oppo as Won " err))))}
      (when reset-focus!
        {:reset-focus! reset-focus!}))))
